module.exports = __webpack_public_path__ + "static/features-phone-immersion-3734ec2e2cff6de0fe7e678afdc74f44.png";